// Extracted from air .babylon file
// 2 mesh(es), 2 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { RuneMesh, RuneMaterials } from "./types.js";

export const AIR_MATERIALS: RuneMaterials = [
  {
    name: "02___Default",
    albedoColor: [0.21570000, 0.21570000, 0.21570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "01___Default",
    albedoColor: [0.84310001, 0.84310001, 0.84310001],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
];

const AIR_MESH_0: RuneMesh = {
  name: "Air_Rune_primitive0",
  positions: new Float32Array([
    -0.79460001, 0.43309999, -0.00000003,
    -0.83679998, 0.42829999, -0.00000003,
    -0.81849998, 0.42829999, -0.17400002,
    -0.77719998, 0.43309999, -0.16520002,
    -0.72589999, 0.43309996, -0.32320002,
    -0.64289999, 0.43309996, -0.46710002,
    -0.53170002, 0.43309996, -0.59050006,
    -0.39730000, 0.43309993, -0.68820006,
    -0.24550000, 0.43309993, -0.75570005,
    -0.08310000, 0.43309993, -0.79030007,
    0.08310000, 0.43309993, -0.79030007,
    0.24550000, 0.43309993, -0.75570005,
    0.39730000, 0.43309993, -0.68820006,
    0.53170002, 0.43309996, -0.59050006,
    0.64289999, 0.43309996, -0.46710002,
    0.72589999, 0.43309996, -0.32320002,
    0.77719998, 0.43309999, -0.16520002,
    0.79460001, 0.43309999, -0.00000003,
    0.77719998, 0.43309999, 0.16519997,
    0.72589999, 0.43310001, 0.32319996,
    0.56819999, 0.43310001, 0.20429997,
    0.56819999, 0.43310001, 0.20429997,
    0.61240000, 0.43309999, -0.16260003,
    0.61240000, 0.43309999, -0.16260003,
    0.41880000, 0.43309999, -0.06070003,
    0.41880000, 0.43309999, -0.06070003,
    0.41880000, 0.43309999, -0.06070003,
    0.38139999, 0.43309999, 0.12279997,
    0.38139999, 0.43309999, 0.12279997,
    0.64289999, 0.43310001, 0.46709996,
    0.53170002, 0.43310001, 0.59049994,
    0.39730000, 0.43310004, 0.68809992,
    0.24550000, 0.43310004, 0.75569993,
    0.08310000, 0.43310004, 0.79029995,
    0.00770000, 0.43310001, 0.57789993,
    0.00770000, 0.43310001, 0.57789993,
    0.10290000, 0.43310001, 0.54059994,
    0.10290000, 0.43310001, 0.54059994,
    0.23870000, 0.43310001, 0.48619998,
    0.23870000, 0.43310001, 0.48619998,
    0.23870000, 0.43310001, 0.48619998,
    0.38479999, 0.43310001, 0.44879997,
    0.38479999, 0.43310001, 0.44879997,
    0.47310001, 0.43310001, 0.38769996,
    0.47310001, 0.43310001, 0.38769996,
    0.28630000, 0.43309999, 0.12279997,
    0.28630000, 0.43309999, 0.12279997,
    0.28630000, 0.43309999, 0.12279997,
    0.33379999, 0.43309999, -0.07430003,
    0.33379999, 0.43309999, -0.07430003,
    0.51730001, 0.43309996, -0.34940004,
    0.51730001, 0.43309996, -0.34940004,
    0.51730001, 0.43309996, -0.34940004,
    0.42219999, 0.43309996, -0.39020002,
    0.42219999, 0.43309996, -0.39020002,
    0.19120000, 0.43309999, -0.10480003,
    0.19120000, 0.43309999, -0.10480003,
    0.14700000, 0.43310001, 0.21109997,
    0.14700000, 0.43310001, 0.21109997,
    0.05530000, 0.43310001, 0.21449997,
    0.05530000, 0.43310001, 0.21449997,
    0.09950000, 0.43309999, -0.15580003,
    0.09950000, 0.43309999, -0.15580003,
    0.28290001, 0.43309996, -0.43770003,
    0.28290001, 0.43309996, -0.43770003,
    0.28290001, 0.43309996, -0.43770003,
    0.15040000, 0.43309996, -0.48870003,
    0.15040000, 0.43309996, -0.48870003,
    -0.08740000, 0.43309996, -0.24750003,
    -0.08740000, 0.43309996, -0.24750003,
    -0.13150001, 0.43310001, 0.20769997,
    -0.13150001, 0.43310001, 0.20769997,
    -0.31160000, 0.43309999, 0.16689996,
    -0.31160000, 0.43309999, 0.16689996,
    -0.27079999, 0.43309996, -0.20330003,
    -0.27079999, 0.43309996, -0.20330003,
    0.05870000, 0.43309996, -0.53280008,
    0.05870000, 0.43309996, -0.53280008,
    -0.13490000, 0.43309993, -0.62790006,
    -0.13490000, 0.43309993, -0.62790006,
    -0.50860000, 0.43309996, -0.34260002,
    -0.50860000, 0.43309996, -0.34260002,
    -0.50860000, 0.43309996, -0.34260002,
    -0.54930001, 0.43310001, 0.30279997,
    -0.54930001, 0.43310001, 0.30279997,
    -0.17569999, 0.43310001, 0.57789993,
    -0.17569999, 0.43310001, 0.57789993,
    -0.08310000, 0.43310004, 0.79029995,
    -0.24550000, 0.43310004, 0.75569993,
    -0.39730000, 0.43310004, 0.68809992,
    -0.53170002, 0.43310001, 0.59049994,
    -0.64289999, 0.43310001, 0.46709996,
    -0.72589999, 0.43310001, 0.32319996,
    -0.77719998, 0.43309999, 0.16519997,
    -0.81849998, 0.42829999, 0.17399997,
    -0.87690002, 0.41429999, -0.00000003,
    -0.85769999, 0.41429999, -0.18230003,
    -0.76450002, 0.42829996, -0.34040004,
    -0.67699999, 0.42829996, -0.49190003,
    -0.55989999, 0.42829993, -0.62190008,
    -0.41839999, 0.42829993, -0.72470003,
    -0.25860000, 0.42829993, -0.79590005,
    -0.08750000, 0.42829993, -0.83220005,
    0.08750000, 0.42829993, -0.83220005,
    0.25860000, 0.42829993, -0.79590005,
    0.41839999, 0.42829993, -0.72470003,
    0.55989999, 0.42829993, -0.62190008,
    0.67699999, 0.42829996, -0.49190003,
    0.76450002, 0.42829996, -0.34040004,
    0.81849998, 0.42829999, -0.17400002,
    0.83679998, 0.42829999, -0.00000003,
    0.81849998, 0.42829999, 0.17399997,
    0.76450002, 0.42830002, 0.34039998,
    0.67699999, 0.42830002, 0.49189997,
    0.55989999, 0.42830005, 0.62189996,
    0.41839999, 0.42830005, 0.72469991,
    0.25860000, 0.42830005, 0.79579991,
    0.08750000, 0.42830005, 0.83219993,
    -0.08750000, 0.42830005, 0.83219993,
    -0.25860000, 0.42830005, 0.79579991,
    -0.41839999, 0.42830005, 0.72469991,
    -0.55989999, 0.42830005, 0.62189996,
    -0.67699999, 0.42830002, 0.49189997,
    -0.76450002, 0.42830002, 0.34039998,
    -0.85769999, 0.41429999, 0.18229997,
    -0.91280001, 0.39170000, -0.00000003,
    -0.89289999, 0.39170000, -0.18980002,
    -0.80110002, 0.41429996, -0.35670003,
    -0.70940000, 0.41429996, -0.51540005,
    -0.58679998, 0.41429994, -0.65170008,
    -0.43840000, 0.41429994, -0.75940007,
    -0.27100000, 0.41429994, -0.83400005,
    -0.09170000, 0.41429994, -0.87210006,
    0.09170000, 0.41429994, -0.87210006,
    0.27100000, 0.41429994, -0.83400005,
    0.43840000, 0.41429994, -0.75940007,
    0.58679998, 0.41429994, -0.65170008,
    0.70940000, 0.41429996, -0.51540005,
    0.80110002, 0.41429996, -0.35670003,
    0.85769999, 0.41429999, -0.18230003,
    0.87690002, 0.41429999, -0.00000003,
    0.85769999, 0.41429999, 0.18229997,
    0.80110002, 0.41430002, 0.35669997,
    0.70940000, 0.41430002, 0.51539993,
    0.58679998, 0.41430005, 0.65169996,
    0.43840000, 0.41430005, 0.75939995,
    0.27100000, 0.41430005, 0.83399993,
    0.09170000, 0.41430005, 0.87209994,
    -0.09170000, 0.41430005, 0.87209994,
    -0.27100000, 0.41430005, 0.83399993,
    -0.43840000, 0.41430005, 0.75939995,
    -0.58679998, 0.41430005, 0.65169996,
    -0.70940000, 0.41430002, 0.51539993,
    -0.80110002, 0.41430002, 0.35669997,
    -0.89289999, 0.39170000, 0.18979996,
    -0.94290000, 0.36170000, -0.00000003,
    -0.92229998, 0.36170000, -0.19600002,
    -0.83389997, 0.39169997, -0.37130004,
    -0.73850000, 0.39169997, -0.53659999,
    -0.61080003, 0.39169994, -0.67839998,
    -0.45640001, 0.39169994, -0.79060000,
    -0.28209999, 0.39169994, -0.86820000,
    -0.09540000, 0.39169994, -0.90789998,
    0.09540000, 0.39169994, -0.90789998,
    0.28209999, 0.39169994, -0.86820000,
    0.45640001, 0.39169994, -0.79060000,
    0.61080003, 0.39169994, -0.67839998,
    0.73850000, 0.39169997, -0.53659999,
    0.83389997, 0.39169997, -0.37130004,
    0.89289999, 0.39170000, -0.18980002,
    0.91280001, 0.39170000, -0.00000003,
    0.89289999, 0.39170000, 0.18979996,
    0.83389997, 0.39170003, 0.37129998,
    0.73850000, 0.39170003, 0.53659999,
    0.61080003, 0.39170006, 0.67839998,
    0.45640001, 0.39170006, 0.79049999,
    0.28209999, 0.39170006, 0.86820000,
    0.09540000, 0.39170006, 0.90780002,
    -0.09540000, 0.39170006, 0.90780002,
    -0.28209999, 0.39170006, 0.86820000,
    -0.45640001, 0.39170006, 0.79049999,
    -0.61080003, 0.39170006, 0.67839998,
    -0.73850000, 0.39170003, 0.53659999,
    -0.83389997, 0.39170003, 0.37129998,
    -0.92229998, 0.36170000, 0.19599997,
    -0.96550000, 0.32570001, -0.00000002,
    -0.94440001, 0.32569999, -0.20070003,
    -0.86140001, 0.36169997, -0.38350004,
    -0.76279998, 0.36169997, -0.55419999,
    -0.63090003, 0.36169994, -0.70069999,
    -0.47139999, 0.36169994, -0.81660002,
    -0.29139999, 0.36169994, -0.89670002,
    -0.09860000, 0.36169994, -0.93769997,
    0.09860000, 0.36169994, -0.93769997,
    0.29139999, 0.36169994, -0.89670002,
    0.47139999, 0.36169994, -0.81660002,
    0.63090003, 0.36169994, -0.70069999,
    0.76279998, 0.36169997, -0.55419999,
    0.86140001, 0.36169997, -0.38350004,
    0.92229998, 0.36170000, -0.19600002,
    0.94290000, 0.36170000, -0.00000003,
    0.92229998, 0.36170000, 0.19599997,
    0.86140001, 0.36170003, 0.38349998,
    0.76279998, 0.36170003, 0.55419999,
    0.63090003, 0.36170006, 0.70069999,
    0.47139999, 0.36170006, 0.81660002,
    0.29139999, 0.36170006, 0.89670002,
    0.09860000, 0.36170006, 0.93769997,
    -0.09860000, 0.36170006, 0.93769997,
    -0.29139999, 0.36170006, 0.89670002,
    -0.47139999, 0.36170006, 0.81660002,
    -0.63090003, 0.36170006, 0.70069999,
    -0.76279998, 0.36170003, 0.55419999,
    -0.86140001, 0.36170003, 0.38349998,
    -0.94440001, 0.32570004, 0.20069997,
    -0.97950000, 0.28560001, -0.00000002,
    -0.95810002, 0.28559998, -0.20370002,
    -0.88200003, 0.32569999, -0.39270002,
    -0.78109998, 0.32569999, -0.56750000,
    -0.64600003, 0.32569996, -0.71749997,
    -0.48269999, 0.32569996, -0.83609998,
    -0.29830000, 0.32569996, -0.91820002,
    -0.10090000, 0.32569996, -0.96020001,
    0.10090000, 0.32569996, -0.96020001,
    0.29830000, 0.32569996, -0.91820002,
    0.48269999, 0.32569996, -0.83609998,
    0.64600003, 0.32569996, -0.71749997,
    0.78109998, 0.32569999, -0.56750000,
    0.88200003, 0.32569999, -0.39270002,
    0.94440001, 0.32569999, -0.20070003,
    0.96550000, 0.32570001, -0.00000002,
    0.94440001, 0.32570004, 0.20069997,
    0.88200003, 0.32570004, 0.39269996,
    0.78109998, 0.32570004, 0.56750000,
    0.64600003, 0.32570007, 0.71749997,
    0.48269999, 0.32570007, 0.83609998,
    0.29830000, 0.32570007, 0.91820002,
    0.10090000, 0.32570007, 0.96020001,
    -0.10090000, 0.32570007, 0.96020001,
    -0.29830000, 0.32570007, 0.91820002,
    -0.48269999, 0.32570007, 0.83609998,
    -0.64600003, 0.32570007, 0.71749997,
    -0.78109998, 0.32570004, 0.56750000,
    -0.88200003, 0.32570004, 0.39269996,
    -0.95810002, 0.28560004, 0.20359999,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.89480001, 0.28559998, -0.39840004,
    -0.79240000, 0.28559998, -0.57569999,
    -0.65539998, 0.28559995, -0.72790003,
    -0.48969999, 0.28559995, -0.84829998,
    -0.30270001, 0.28559995, -0.93159997,
    -0.10240000, 0.28559995, -0.97409999,
    0.10240000, 0.28559995, -0.97409999,
    0.30270001, 0.28559995, -0.93159997,
    0.48969999, 0.28559995, -0.84829998,
    0.65539998, 0.28559995, -0.72790003,
    0.79240000, 0.28559998, -0.57569999,
    0.89480001, 0.28559998, -0.39840004,
    0.95810002, 0.28559998, -0.20370002,
    0.97950000, 0.28560001, -0.00000002,
    0.95810002, 0.28560004, 0.20359999,
    0.89480001, 0.28560004, 0.39839998,
    0.79240000, 0.28560004, 0.57569999,
    0.65539998, 0.28560007, 0.72790003,
    0.48969999, 0.28560007, 0.84829998,
    0.30270001, 0.28560007, 0.93159997,
    0.10240000, 0.28560007, 0.97409999,
    -0.10240000, 0.28560007, 0.97409999,
    -0.30270001, 0.28560007, 0.93159997,
    -0.48980001, 0.28560007, 0.84829998,
    -0.65539998, 0.28560007, 0.72790003,
    -0.79240000, 0.28560004, 0.57569999,
    -0.89480001, 0.28560004, 0.39839998,
    -0.96270001, 0.24340001, 0.20459999,
    -0.96270001, 0.24340001, 0.20459999,
    -0.98430002, 0.21650000, -0.00000002,
    -0.98430002, 0.21650000, -0.00000002,
    -0.96270001, 0.21649998, -0.20460002,
    -0.89920002, 0.24339996, -0.40030003,
    -0.89920002, 0.24339996, -0.40030003,
    -0.79629999, 0.24339995, -0.57849997,
    -0.79629999, 0.24339995, -0.57849997,
    -0.65859997, 0.24339993, -0.73140001,
    -0.65859997, 0.24339993, -0.73140001,
    -0.49210000, 0.24339993, -0.85240000,
    -0.49210000, 0.24339993, -0.85240000,
    -0.30419999, 0.24339992, -0.93610001,
    -0.30419999, 0.24339992, -0.93610001,
    -0.10290000, 0.24339992, -0.97890002,
    -0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.30419999, 0.24339992, -0.93610001,
    0.30419999, 0.24339992, -0.93610001,
    0.49210000, 0.24339993, -0.85240000,
    0.49210000, 0.24339993, -0.85240000,
    0.65859997, 0.24339993, -0.73140001,
    0.65859997, 0.24339993, -0.73140001,
    0.79629999, 0.24339995, -0.57849997,
    0.79629999, 0.24339995, -0.57849997,
    0.89920002, 0.24339996, -0.40030003,
    0.89920002, 0.24339996, -0.40030003,
    0.96270001, 0.24339998, -0.20460002,
    0.96270001, 0.24339998, -0.20460002,
    0.98430002, 0.24339999, -0.00000002,
    0.98430002, 0.24339999, -0.00000002,
    0.96270001, 0.24340001, 0.20459999,
    0.96270001, 0.24340001, 0.20459999,
    0.89920002, 0.24340002, 0.40029997,
    0.89920002, 0.24340002, 0.40029997,
    0.79629999, 0.24340004, 0.57849997,
    0.79629999, 0.24340004, 0.57849997,
    0.65859997, 0.24340005, 0.73140001,
    0.65859997, 0.24340005, 0.73140001,
    0.49210000, 0.24340005, 0.85240000,
    0.49210000, 0.24340005, 0.85240000,
    0.30410001, 0.24340007, 0.93610001,
    0.30410001, 0.24340007, 0.93610001,
    0.10290000, 0.24340007, 0.97890002,
    0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.30419999, 0.24340007, 0.93610001,
    -0.30419999, 0.24340007, 0.93610001,
    -0.49210000, 0.24340005, 0.85240000,
    -0.49210000, 0.24340005, 0.85240000,
    -0.65859997, 0.24340005, 0.73140001,
    -0.65859997, 0.24340005, 0.73140001,
    -0.79629999, 0.24340004, 0.57849997,
    -0.79629999, 0.24340004, 0.57849997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.96270001, 0.21650001, 0.20459999,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.96270001, 0.18959999, -0.20460002,
    -0.96270001, 0.18959999, -0.20460002,
    -0.89920002, 0.21649997, -0.40030003,
    -0.79629999, 0.21649995, -0.57849997,
    -0.65859997, 0.21649994, -0.73140001,
    -0.49210000, 0.21649994, -0.85240000,
    -0.30419999, 0.21649992, -0.93610001,
    -0.10290000, 0.21649992, -0.97890002,
    0.10290000, 0.21649992, -0.97890002,
    0.30419999, 0.21649992, -0.93610001,
    0.49210000, 0.21649994, -0.85240000,
    0.65859997, 0.21649994, -0.73140001,
    0.79629999, 0.21649995, -0.57849997,
    0.89920002, 0.21649997, -0.40030003,
    0.96270001, 0.21649998, -0.20460002,
    0.98430002, 0.21650000, -0.00000002,
    0.96270001, 0.21650001, 0.20459999,
    0.89920002, 0.21650003, 0.40029997,
    0.79629999, 0.21650004, 0.57849997,
    0.65859997, 0.21650006, 0.73140001,
    0.49210000, 0.21650006, 0.85240000,
    0.30410001, 0.21650007, 0.93610001,
    0.10290000, 0.21650007, 0.97890002,
    -0.10290000, 0.21650007, 0.97890002,
    -0.30419999, 0.21650007, 0.93610001,
    -0.49210000, 0.21650006, 0.85240000,
    -0.65859997, 0.21650006, 0.73140001,
    -0.79629999, 0.21650004, 0.57849997,
    -0.89920002, 0.21650003, 0.40029997,
    -0.96270001, 0.18960002, 0.20459999,
    -0.96270001, 0.18960002, 0.20459999,
    -0.97950000, 0.14740001, -0.00000001,
    -0.95810002, 0.14739999, -0.20370002,
    -0.89920002, 0.18959998, -0.40030000,
    -0.89920002, 0.18959998, -0.40030000,
    -0.79629999, 0.18959996, -0.57849997,
    -0.79629999, 0.18959996, -0.57849997,
    -0.65859997, 0.18959995, -0.73140001,
    -0.65859997, 0.18959995, -0.73140001,
    -0.49210000, 0.18959995, -0.85240000,
    -0.49210000, 0.18959995, -0.85240000,
    -0.30419999, 0.18959993, -0.93610001,
    -0.30419999, 0.18959993, -0.93610001,
    -0.10290000, 0.18959993, -0.97890002,
    -0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.30419999, 0.18959993, -0.93610001,
    0.30419999, 0.18959993, -0.93610001,
    0.49210000, 0.18959995, -0.85240000,
    0.49210000, 0.18959995, -0.85240000,
    0.65859997, 0.18959995, -0.73140001,
    0.65859997, 0.18959995, -0.73140001,
    0.79629999, 0.18959996, -0.57849997,
    0.79629999, 0.18959996, -0.57849997,
    0.89920002, 0.18959998, -0.40030000,
    0.89920002, 0.18959998, -0.40030000,
    0.96270001, 0.18959999, -0.20460002,
    0.96270001, 0.18959999, -0.20460002,
    0.98430002, 0.18960001, -0.00000001,
    0.98430002, 0.18960001, -0.00000001,
    0.96270001, 0.18960002, 0.20459999,
    0.96270001, 0.18960002, 0.20459999,
    0.89920002, 0.18960004, 0.40030000,
    0.89920002, 0.18960004, 0.40030000,
    0.79629999, 0.18960005, 0.57849997,
    0.79629999, 0.18960005, 0.57849997,
    0.65859997, 0.18960007, 0.73140001,
    0.65859997, 0.18960007, 0.73140001,
    0.49210000, 0.18960007, 0.85240000,
    0.49210000, 0.18960007, 0.85240000,
    0.30410001, 0.18960008, 0.93610001,
    0.30410001, 0.18960008, 0.93610001,
    0.10290000, 0.18960008, 0.97890002,
    0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.30419999, 0.18960008, 0.93610001,
    -0.30419999, 0.18960008, 0.93610001,
    -0.49210000, 0.18960007, 0.85240000,
    -0.49210000, 0.18960007, 0.85240000,
    -0.65859997, 0.18960007, 0.73140001,
    -0.65859997, 0.18960007, 0.73140001,
    -0.79629999, 0.18960005, 0.57849997,
    -0.79629999, 0.18960005, 0.57849997,
    -0.89920002, 0.18960004, 0.40030000,
    -0.89920002, 0.18960004, 0.40030000,
    -0.95810002, 0.14740002, 0.20359999,
    -0.96550000, 0.10740000, -0.00000001,
    -0.94440001, 0.10739999, -0.20070001,
    -0.89480001, 0.14739998, -0.39840001,
    -0.79240000, 0.14739996, -0.57569999,
    -0.65539998, 0.14739995, -0.72790003,
    -0.48969999, 0.14739995, -0.84829998,
    -0.30270001, 0.14739993, -0.93159997,
    -0.10240000, 0.14739993, -0.97409999,
    0.10240000, 0.14739993, -0.97409999,
    0.30270001, 0.14739993, -0.93159997,
    0.48969999, 0.14739995, -0.84829998,
    0.65539998, 0.14739995, -0.72790003,
    0.79240000, 0.14739996, -0.57569999,
    0.89480001, 0.14739998, -0.39840001,
    0.95810002, 0.14739999, -0.20370002,
    0.97950000, 0.14740001, -0.00000001,
    0.95810002, 0.14740002, 0.20359999,
    0.89480001, 0.14740004, 0.39840001,
    0.79240000, 0.14740005, 0.57569999,
    0.65539998, 0.14740007, 0.72790003,
    0.48969999, 0.14740007, 0.84829998,
    0.30270001, 0.14740008, 0.93159997,
    0.10240000, 0.14740008, 0.97409999,
    -0.10240000, 0.14740008, 0.97409999,
    -0.30270001, 0.14740008, 0.93159997,
    -0.48980001, 0.14740007, 0.84829998,
    -0.65539998, 0.14740007, 0.72790003,
    -0.79240000, 0.14740005, 0.57569999,
    -0.89480001, 0.14740004, 0.39840001,
    -0.94440001, 0.10740001, 0.20069999,
    -0.94290000, 0.07140000, -0.00000001,
    -0.92229998, 0.07139999, -0.19599999,
    -0.88200003, 0.10739997, -0.39269999,
    -0.78109998, 0.10739996, -0.56750000,
    -0.64600003, 0.10739995, -0.71749997,
    -0.48269999, 0.10739994, -0.83609998,
    -0.29830000, 0.10739993, -0.91820002,
    -0.10090000, 0.10739993, -0.96020001,
    0.10090000, 0.10739993, -0.96020001,
    0.29830000, 0.10739993, -0.91820002,
    0.48269999, 0.10739994, -0.83609998,
    0.64600003, 0.10739995, -0.71749997,
    0.78109998, 0.10739996, -0.56750000,
    0.88200003, 0.10739997, -0.39269999,
    0.94440001, 0.10739999, -0.20070001,
    0.96550000, 0.10740000, -0.00000001,
    0.94440001, 0.10740001, 0.20069999,
    0.88200003, 0.10740003, 0.39269999,
    0.78109998, 0.10740004, 0.56750000,
    0.64600003, 0.10740005, 0.71749997,
    0.48269999, 0.10740006, 0.83609998,
    0.29830000, 0.10740007, 0.91820002,
    0.10090000, 0.10740007, 0.96020001,
    -0.10090000, 0.10740007, 0.96020001,
    -0.29830000, 0.10740007, 0.91820002,
    -0.48269999, 0.10740006, 0.83609998,
    -0.64600003, 0.10740005, 0.71749997,
    -0.78109998, 0.10740004, 0.56750000,
    -0.88200003, 0.10740003, 0.39269999,
    -0.92229998, 0.07140002, 0.19599999,
    -0.91280001, 0.04140000, -0.00000000,
    -0.89289999, 0.04139999, -0.18979999,
    -0.86140001, 0.07139997, -0.38350001,
    -0.76279998, 0.07139996, -0.55419999,
    -0.63090003, 0.07139995, -0.70069999,
    -0.47139999, 0.07139994, -0.81660002,
    -0.29139999, 0.07139993, -0.89670002,
    -0.09860000, 0.07139993, -0.93769997,
    0.09860000, 0.07139993, -0.93769997,
    0.29139999, 0.07139993, -0.89670002,
    0.47139999, 0.07139994, -0.81660002,
    0.63090003, 0.07139995, -0.70069999,
    0.76279998, 0.07139996, -0.55419999,
    0.86140001, 0.07139997, -0.38350001,
    0.92229998, 0.07139999, -0.19599999,
    0.94290000, 0.07140000, -0.00000001,
    0.92229998, 0.07140002, 0.19599999,
    0.86140001, 0.07140003, 0.38350001,
    0.76279998, 0.07140005, 0.55419999,
    0.63090003, 0.07140005, 0.70069999,
    0.47139999, 0.07140006, 0.81660002,
    0.29139999, 0.07140007, 0.89670002,
    0.09860000, 0.07140008, 0.93769997,
    -0.09860000, 0.07140008, 0.93769997,
    -0.29139999, 0.07140007, 0.89670002,
    -0.47139999, 0.07140006, 0.81660002,
    -0.63090003, 0.07140005, 0.70069999,
    -0.76279998, 0.07140005, 0.55419999,
    -0.86140001, 0.07140003, 0.38350001,
    -0.89289999, 0.04140002, 0.18979999,
    -0.87690002, 0.01880000, -0.00000000,
    -0.85769999, 0.01879999, -0.18230000,
    -0.83389997, 0.04139997, -0.37130001,
    -0.73850000, 0.04139996, -0.53659999,
    -0.61080003, 0.04139995, -0.67839998,
    -0.45640001, 0.04139994, -0.79060000,
    -0.28209999, 0.04139993, -0.86820000,
    -0.09540000, 0.04139993, -0.90789998,
    0.09540000, 0.04139993, -0.90789998,
    0.28209999, 0.04139993, -0.86820000,
    0.45640001, 0.04139994, -0.79060000,
    0.61080003, 0.04139995, -0.67839998,
    0.73850000, 0.04139996, -0.53659999,
    0.83389997, 0.04139997, -0.37130001,
    0.89289999, 0.04139999, -0.18979999,
    0.91280001, 0.04140000, -0.00000000,
    0.89289999, 0.04140002, 0.18979999,
    0.83389997, 0.04140003, 0.37130001,
    0.73850000, 0.04140004, 0.53659999,
    0.61080003, 0.04140005, 0.67839998,
    0.45640001, 0.04140006, 0.79049999,
    0.28209999, 0.04140007, 0.86820000,
    0.09540000, 0.04140007, 0.90780002,
    -0.09540000, 0.04140007, 0.90780002,
    -0.28209999, 0.04140007, 0.86820000,
    -0.45640001, 0.04140006, 0.79049999,
    -0.61080003, 0.04140005, 0.67839998,
    -0.73850000, 0.04140004, 0.53659999,
    -0.83389997, 0.04140003, 0.37130001,
    -0.85769999, 0.01880001, 0.18230000,
    -0.83679998, 0.00480000, -0.00000000,
    -0.81849998, 0.00479999, -0.17399999,
    -0.80110002, 0.01879997, -0.35670000,
    -0.70940000, 0.01879996, -0.51539999,
    -0.58679998, 0.01879995, -0.65170002,
    -0.43840000, 0.01879994, -0.75940001,
    -0.27100000, 0.01879994, -0.83399999,
    -0.09170000, 0.01879993, -0.87210000,
    0.09170000, 0.01879993, -0.87210000,
    0.27100000, 0.01879994, -0.83399999,
    0.43840000, 0.01879994, -0.75940001,
    0.58679998, 0.01879995, -0.65170002,
    0.70940000, 0.01879996, -0.51539999,
    0.80110002, 0.01879997, -0.35670000,
    0.85769999, 0.01879999, -0.18230000,
    0.87690002, 0.01880000, -0.00000000,
    0.85769999, 0.01880001, 0.18230000,
    0.80110002, 0.01880003, 0.35670000,
    0.70940000, 0.01880004, 0.51539999,
    0.58679998, 0.01880005, 0.65170002,
    0.43840000, 0.01880006, 0.75940001,
    0.27100000, 0.01880006, 0.83399999,
    0.09170000, 0.01880006, 0.87210000,
    -0.09170000, 0.01880006, 0.87210000,
    -0.27100000, 0.01880006, 0.83399999,
    -0.43840000, 0.01880006, 0.75940001,
    -0.58679998, 0.01880005, 0.65170002,
    -0.70940000, 0.01880004, 0.51539999,
    -0.80110002, 0.01880003, 0.35670000,
    -0.81849998, 0.00480001, 0.17399999,
    -0.79460001, 0.00000000, 0.00000000,
    -0.77719998, -0.00000001, -0.16520000,
    -0.76450002, 0.00479997, -0.34040001,
    -0.67699999, 0.00479996, -0.49190000,
    -0.55989999, 0.00479995, -0.62190002,
    -0.41839999, 0.00479995, -0.72469997,
    -0.25860000, 0.00479994, -0.79589999,
    -0.08750000, 0.00479994, -0.83219999,
    0.08750000, 0.00479994, -0.83219999,
    0.25860000, 0.00479994, -0.79589999,
    0.41839999, 0.00479995, -0.72469997,
    0.55989999, 0.00479995, -0.62190002,
    0.67699999, 0.00479996, -0.49190000,
    0.76450002, 0.00479997, -0.34040001,
    0.81849998, 0.00479999, -0.17399999,
    0.83679998, 0.00480000, -0.00000000,
    0.81849998, 0.00480001, 0.17399999,
    0.76450002, 0.00480003, 0.34040001,
    0.67699999, 0.00480004, 0.49190000,
    0.55989999, 0.00480005, 0.62190002,
    0.41839999, 0.00480005, 0.72469997,
    0.25860000, 0.00480006, 0.79579997,
    0.08750000, 0.00480006, 0.83219999,
    -0.08750000, 0.00480006, 0.83219999,
    -0.25860000, 0.00480006, 0.79579997,
    -0.41839999, 0.00480005, 0.72469997,
    -0.55989999, 0.00480005, 0.62190002,
    -0.67699999, 0.00480004, 0.49190000,
    -0.76450002, 0.00480003, 0.34040001,
    -0.77719998, 0.00000001, 0.16520000,
    0.00000000, 0.00000000, 0.00000000,
    -0.72589999, -0.00000002, -0.32319999,
    -0.64289999, -0.00000004, -0.46709999,
    -0.53170002, -0.00000004, -0.59050000,
    -0.39730000, -0.00000005, -0.68820000,
    -0.24550000, -0.00000006, -0.75569999,
    -0.08310000, -0.00000006, -0.79030001,
    0.08310000, -0.00000006, -0.79030001,
    0.24550000, -0.00000006, -0.75569999,
    0.39730000, -0.00000005, -0.68820000,
    0.53170002, -0.00000004, -0.59050000,
    0.64289999, -0.00000004, -0.46709999,
    0.72589999, -0.00000002, -0.32319999,
    0.77719998, -0.00000001, -0.16520000,
    0.79460001, 0.00000000, 0.00000000,
    0.77719998, 0.00000001, 0.16520000,
    0.72589999, 0.00000002, 0.32319999,
    0.64289999, 0.00000004, 0.46709999,
    0.53170002, 0.00000004, 0.59050000,
    0.39730000, 0.00000005, 0.68809998,
    0.24550000, 0.00000006, 0.75569999,
    0.08310000, 0.00000006, 0.79030001,
    -0.08310000, 0.00000006, 0.79030001,
    -0.24550000, 0.00000006, 0.75569999,
    -0.39730000, 0.00000005, 0.68809998,
    -0.53170002, 0.00000004, 0.59050000,
    -0.64289999, 0.00000004, 0.46709999,
    -0.72589999, 0.00000002, 0.32319999,
    0.00770000, 0.36710003, 0.57789999,
    -0.31160000, 0.36710000, 0.16689996,
    -0.27079999, 0.36709997, -0.20330003,
    -0.17569999, 0.36710003, 0.57789999,
    -0.54930001, 0.36710003, 0.30279997,
    -0.50860000, 0.36709997, -0.34260002,
    -0.13490000, 0.36709994, -0.62790000,
    0.05870000, 0.36709997, -0.53280002,
    0.23870000, 0.36710003, 0.48619998,
    0.05530000, 0.36710003, 0.21449997,
    0.09950000, 0.36710000, -0.15580003,
    0.10290000, 0.36710003, 0.54060000,
    -0.13150001, 0.36710003, 0.20769997,
    -0.08740000, 0.36709997, -0.24750003,
    0.15040000, 0.36709997, -0.48870003,
    0.28290001, 0.36709997, -0.43770003,
    0.28290001, 0.36709997, -0.43770003,
    0.51730001, 0.36709997, -0.34940004,
    0.42219999, 0.36709997, -0.39020002,
    0.19120000, 0.36710000, -0.10480003,
    0.33379999, 0.36710000, -0.07430003,
    0.28630000, 0.36710000, 0.12279997,
    0.28630000, 0.36710000, 0.12279997,
    0.47310001, 0.36710003, 0.38769996,
    0.38479999, 0.36710003, 0.44879997,
    0.14700000, 0.36710003, 0.21109997,
    0.61240000, 0.36710000, -0.16260003,
    0.41880000, 0.36710000, -0.06070003,
    0.38139999, 0.36710000, 0.12279997,
    0.56819999, 0.36710003, 0.20429997,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 20, 27, 664, 20, 664, 665,
    93, 94, 1, 93, 1, 0, 1, 95, 96, 1, 96, 2,
    3, 2, 97, 3, 97, 4, 4, 97, 98, 4, 98, 5,
    5, 98, 99, 5, 99, 6, 6, 99, 100, 6, 100, 7,
    7, 100, 101, 7, 101, 8, 8, 101, 102, 8, 102, 9,
    9, 102, 103, 9, 103, 10, 10, 103, 104, 10, 104, 11,
    11, 104, 105, 11, 105, 12, 12, 105, 106, 12, 106, 13,
    13, 106, 107, 13, 107, 14, 14, 107, 108, 14, 108, 15,
    15, 108, 109, 15, 109, 16, 16, 109, 110, 16, 110, 17,
    17, 110, 111, 17, 111, 18, 18, 111, 112, 18, 112, 19,
    19, 112, 113, 19, 113, 29, 29, 113, 114, 29, 114, 30,
    30, 114, 115, 30, 115, 31, 31, 115, 116, 31, 116, 32,
    32, 116, 117, 32, 117, 33, 33, 117, 118, 33, 118, 87,
    87, 118, 119, 87, 119, 88, 88, 119, 120, 88, 120, 89,
    89, 120, 121, 89, 121, 90, 90, 121, 122, 90, 122, 91,
    91, 122, 123, 91, 123, 92, 92, 123, 94, 92, 94, 93,
    94, 124, 95, 94, 95, 1, 95, 125, 126, 95, 126, 96,
    2, 96, 127, 2, 127, 97, 97, 127, 128, 97, 128, 98,
    98, 128, 129, 98, 129, 99, 99, 129, 130, 99, 130, 100,
    100, 130, 131, 100, 131, 101, 101, 131, 132, 101, 132, 102,
    102, 132, 133, 102, 133, 103, 103, 133, 134, 103, 134, 104,
    104, 134, 135, 104, 135, 105, 105, 135, 136, 105, 136, 106,
    106, 136, 137, 106, 137, 107, 107, 137, 138, 107, 138, 108,
    108, 138, 139, 108, 139, 109, 109, 139, 140, 109, 140, 110,
    110, 140, 141, 110, 141, 111, 111, 141, 142, 111, 142, 112,
    112, 142, 143, 112, 143, 113, 113, 143, 144, 113, 144, 114,
    114, 144, 145, 114, 145, 115, 115, 145, 146, 115, 146, 116,
    116, 146, 147, 116, 147, 117, 117, 147, 148, 117, 148, 118,
    118, 148, 149, 118, 149, 119, 119, 149, 150, 119, 150, 120,
    120, 150, 151, 120, 151, 121, 121, 151, 152, 121, 152, 122,
    122, 152, 153, 122, 153, 123, 123, 153, 124, 123, 124, 94,
    124, 154, 125, 124, 125, 95, 125, 155, 156, 125, 156, 126,
    96, 126, 157, 96, 157, 127, 127, 157, 158, 127, 158, 128,
    128, 158, 159, 128, 159, 129, 129, 159, 160, 129, 160, 130,
    130, 160, 161, 130, 161, 131, 131, 161, 162, 131, 162, 132,
    132, 162, 163, 132, 163, 133, 133, 163, 164, 133, 164, 134,
    134, 164, 165, 134, 165, 135, 135, 165, 166, 135, 166, 136,
    136, 166, 167, 136, 167, 137, 137, 167, 168, 137, 168, 138,
    138, 168, 169, 138, 169, 139, 139, 169, 170, 139, 170, 140,
    140, 170, 171, 140, 171, 141, 141, 171, 172, 141, 172, 142,
    142, 172, 173, 142, 173, 143, 143, 173, 174, 143, 174, 144,
    144, 174, 175, 144, 175, 145, 145, 175, 176, 145, 176, 146,
    146, 176, 177, 146, 177, 147, 147, 177, 178, 147, 178, 148,
    148, 178, 179, 148, 179, 149, 149, 179, 180, 149, 180, 150,
    150, 180, 181, 150, 181, 151, 151, 181, 182, 151, 182, 152,
    152, 182, 183, 152, 183, 153, 153, 183, 154, 153, 154, 124,
    154, 184, 155, 154, 155, 125, 155, 185, 186, 155, 186, 156,
    126, 156, 187, 126, 187, 157, 157, 187, 188, 157, 188, 158,
    158, 188, 189, 158, 189, 159, 159, 189, 190, 159, 190, 160,
    160, 190, 191, 160, 191, 161, 161, 191, 192, 161, 192, 162,
    162, 192, 193, 162, 193, 163, 163, 193, 194, 163, 194, 164,
    164, 194, 195, 164, 195, 165, 165, 195, 196, 165, 196, 166,
    166, 196, 197, 166, 197, 167, 167, 197, 198, 167, 198, 168,
    168, 198, 199, 168, 199, 169, 169, 199, 200, 169, 200, 170,
    170, 200, 201, 170, 201, 171, 171, 201, 202, 171, 202, 172,
    172, 202, 203, 172, 203, 173, 173, 203, 204, 173, 204, 174,
    174, 204, 205, 174, 205, 175, 175, 205, 206, 175, 206, 176,
    176, 206, 207, 176, 207, 177, 177, 207, 208, 177, 208, 178,
    178, 208, 209, 178, 209, 179, 179, 209, 210, 179, 210, 180,
    180, 210, 211, 180, 211, 181, 181, 211, 212, 181, 212, 182,
    182, 212, 213, 182, 213, 183, 183, 213, 184, 183, 184, 154,
    184, 214, 185, 184, 185, 155, 185, 215, 216, 185, 216, 186,
    156, 186, 217, 156, 217, 187, 187, 217, 218, 187, 218, 188,
    188, 218, 219, 188, 219, 189, 189, 219, 220, 189, 220, 190,
    190, 220, 221, 190, 221, 191, 191, 221, 222, 191, 222, 192,
    192, 222, 223, 192, 223, 193, 193, 223, 224, 193, 224, 194,
    194, 224, 225, 194, 225, 195, 195, 225, 226, 195, 226, 196,
    196, 226, 227, 196, 227, 197, 197, 227, 228, 197, 228, 198,
    198, 228, 229, 198, 229, 199, 199, 229, 230, 199, 230, 200,
    200, 230, 231, 200, 231, 201, 201, 231, 232, 201, 232, 202,
    202, 232, 233, 202, 233, 203, 203, 233, 234, 203, 234, 204,
    204, 234, 235, 204, 235, 205, 205, 235, 236, 205, 236, 206,
    206, 236, 237, 206, 237, 207, 207, 237, 238, 207, 238, 208,
    208, 238, 239, 208, 239, 209, 209, 239, 240, 209, 240, 210,
    210, 240, 241, 210, 241, 211, 211, 241, 242, 211, 242, 212,
    212, 242, 243, 212, 243, 213, 213, 243, 214, 213, 214, 184,
    214, 244, 215, 214, 215, 185, 215, 247, 249, 215, 249, 216,
    186, 216, 250, 186, 250, 217, 217, 250, 251, 217, 251, 218,
    218, 251, 252, 218, 252, 219, 219, 252, 253, 219, 253, 220,
    220, 253, 254, 220, 254, 221, 221, 254, 255, 221, 255, 222,
    222, 255, 256, 222, 256, 223, 223, 256, 257, 223, 257, 224,
    224, 257, 258, 224, 258, 225, 225, 258, 259, 225, 259, 226,
    226, 259, 260, 226, 260, 227, 227, 260, 261, 227, 261, 228,
    228, 261, 262, 228, 262, 229, 229, 262, 263, 229, 263, 230,
    230, 263, 264, 230, 264, 231, 231, 264, 265, 231, 265, 232,
    232, 265, 266, 232, 266, 233, 233, 266, 267, 233, 267, 234,
    234, 267, 268, 234, 268, 235, 235, 268, 269, 235, 269, 236,
    236, 269, 270, 236, 270, 237, 237, 270, 271, 237, 271, 238,
    238, 271, 272, 238, 272, 239, 239, 272, 273, 239, 273, 240,
    240, 273, 274, 240, 274, 241, 241, 274, 275, 241, 275, 242,
    242, 275, 276, 242, 276, 243, 243, 276, 244, 243, 244, 214,
    244, 278, 247, 244, 247, 215, 245, 279, 281, 245, 281, 248,
    216, 249, 283, 216, 283, 250, 250, 283, 285, 250, 285, 251,
    251, 285, 287, 251, 287, 252, 252, 287, 289, 252, 289, 253,
    253, 289, 291, 253, 291, 254, 254, 291, 293, 254, 293, 255,
    255, 293, 295, 255, 295, 256, 256, 295, 297, 256, 297, 257,
    257, 297, 298, 257, 298, 258, 258, 298, 300, 258, 300, 259,
    259, 300, 302, 259, 302, 260, 260, 302, 304, 260, 304, 261,
    261, 304, 306, 261, 306, 262, 262, 306, 308, 262, 308, 263,
    263, 308, 310, 263, 310, 264, 264, 310, 312, 264, 312, 265,
    265, 312, 314, 265, 314, 266, 266, 314, 316, 266, 316, 267,
    267, 316, 318, 267, 318, 268, 268, 318, 320, 268, 320, 269,
    269, 320, 322, 269, 322, 270, 270, 322, 324, 270, 324, 271,
    271, 324, 326, 271, 326, 272, 272, 326, 328, 272, 328, 273,
    273, 328, 330, 273, 330, 274, 274, 330, 333, 274, 333, 275,
    275, 333, 335, 275, 335, 276, 276, 335, 278, 276, 278, 244,
    277, 336, 280, 277, 280, 246, 279, 337, 340, 279, 340, 281,
    248, 281, 342, 248, 342, 282, 282, 342, 343, 282, 343, 284,
    284, 343, 344, 284, 344, 286, 286, 344, 345, 286, 345, 288,
    288, 345, 346, 288, 346, 290, 290, 346, 347, 290, 347, 292,
    292, 347, 348, 292, 348, 294, 294, 348, 349, 294, 349, 296,
    296, 349, 350, 296, 350, 299, 299, 350, 351, 299, 351, 301,
    301, 351, 352, 301, 352, 303, 303, 352, 353, 303, 353, 305,
    305, 353, 354, 305, 354, 307, 307, 354, 355, 307, 355, 309,
    309, 355, 356, 309, 356, 311, 311, 356, 357, 311, 357, 313,
    313, 357, 358, 313, 358, 315, 315, 358, 359, 315, 359, 317,
    317, 359, 360, 317, 360, 319, 319, 360, 361, 319, 361, 321,
    321, 361, 362, 321, 362, 323, 323, 362, 363, 323, 363, 325,
    325, 363, 364, 325, 364, 327, 327, 364, 365, 327, 365, 329,
    329, 365, 366, 329, 366, 331, 331, 366, 367, 331, 367, 332,
    332, 367, 368, 332, 368, 334, 334, 368, 336, 334, 336, 277,
    336, 369, 339, 336, 339, 280, 338, 371, 372, 338, 372, 341,
    281, 340, 373, 281, 373, 342, 342, 373, 375, 342, 375, 343,
    343, 375, 377, 343, 377, 344, 344, 377, 379, 344, 379, 345,
    345, 379, 381, 345, 381, 346, 346, 381, 383, 346, 383, 347,
    347, 383, 385, 347, 385, 348, 348, 385, 387, 348, 387, 349,
    349, 387, 390, 349, 390, 350, 350, 390, 392, 350, 392, 351,
    351, 392, 394, 351, 394, 352, 352, 394, 396, 352, 396, 353,
    353, 396, 398, 353, 398, 354, 354, 398, 400, 354, 400, 355,
    355, 400, 402, 355, 402, 356, 356, 402, 404, 356, 404, 357,
    357, 404, 406, 357, 406, 358, 358, 406, 408, 358, 408, 359,
    359, 408, 410, 359, 410, 360, 360, 410, 412, 360, 412, 361,
    361, 412, 414, 361, 414, 362, 362, 414, 416, 362, 416, 363,
    363, 416, 418, 363, 418, 364, 364, 418, 420, 364, 420, 365,
    365, 420, 422, 365, 422, 366, 366, 422, 423, 366, 423, 367,
    367, 423, 425, 367, 425, 368, 368, 425, 369, 368, 369, 336,
    370, 427, 371, 370, 371, 338, 371, 428, 429, 371, 429, 372,
    341, 372, 430, 341, 430, 374, 374, 430, 431, 374, 431, 376,
    376, 431, 432, 376, 432, 378, 378, 432, 433, 378, 433, 380,
    380, 433, 434, 380, 434, 382, 382, 434, 435, 382, 435, 384,
    384, 435, 436, 384, 436, 386, 386, 436, 437, 386, 437, 388,
    388, 437, 438, 388, 438, 389, 389, 438, 439, 389, 439, 391,
    391, 439, 440, 391, 440, 393, 393, 440, 441, 393, 441, 395,
    395, 441, 442, 395, 442, 397, 397, 442, 443, 397, 443, 399,
    399, 443, 444, 399, 444, 401, 401, 444, 445, 401, 445, 403,
    403, 445, 446, 403, 446, 405, 405, 446, 447, 405, 447, 407,
    407, 447, 448, 407, 448, 409, 409, 448, 449, 409, 449, 411,
    411, 449, 450, 411, 450, 413, 413, 450, 451, 413, 451, 415,
    415, 451, 452, 415, 452, 417, 417, 452, 453, 417, 453, 419,
    419, 453, 454, 419, 454, 421, 421, 454, 455, 421, 455, 424,
    424, 455, 456, 424, 456, 426, 426, 456, 427, 426, 427, 370,
    427, 457, 428, 427, 428, 371, 428, 458, 459, 428, 459, 429,
    372, 429, 460, 372, 460, 430, 430, 460, 461, 430, 461, 431,
    431, 461, 462, 431, 462, 432, 432, 462, 463, 432, 463, 433,
    433, 463, 464, 433, 464, 434, 434, 464, 465, 434, 465, 435,
    435, 465, 466, 435, 466, 436, 436, 466, 467, 436, 467, 437,
    437, 467, 468, 437, 468, 438, 438, 468, 469, 438, 469, 439,
    439, 469, 470, 439, 470, 440, 440, 470, 471, 440, 471, 441,
    441, 471, 472, 441, 472, 442, 442, 472, 473, 442, 473, 443,
    443, 473, 474, 443, 474, 444, 444, 474, 475, 444, 475, 445,
    445, 475, 476, 445, 476, 446, 446, 476, 477, 446, 477, 447,
    447, 477, 478, 447, 478, 448, 448, 478, 479, 448, 479, 449,
    449, 479, 480, 449, 480, 450, 450, 480, 481, 450, 481, 451,
    451, 481, 482, 451, 482, 452, 452, 482, 483, 452, 483, 453,
    453, 483, 484, 453, 484, 454, 454, 484, 485, 454, 485, 455,
    455, 485, 486, 455, 486, 456, 456, 486, 457, 456, 457, 427,
    457, 487, 458, 457, 458, 428, 458, 488, 489, 458, 489, 459,
    429, 459, 490, 429, 490, 460, 460, 490, 491, 460, 491, 461,
    461, 491, 492, 461, 492, 462, 462, 492, 493, 462, 493, 463,
    463, 493, 494, 463, 494, 464, 464, 494, 495, 464, 495, 465,
    465, 495, 496, 465, 496, 466, 466, 496, 497, 466, 497, 467,
    467, 497, 498, 467, 498, 468, 468, 498, 499, 468, 499, 469,
    469, 499, 500, 469, 500, 470, 470, 500, 501, 470, 501, 471,
    471, 501, 502, 471, 502, 472, 472, 502, 503, 472, 503, 473,
    473, 503, 504, 473, 504, 474, 474, 504, 505, 474, 505, 475,
    475, 505, 506, 475, 506, 476, 476, 506, 507, 476, 507, 477,
    477, 507, 508, 477, 508, 478, 478, 508, 509, 478, 509, 479,
    479, 509, 510, 479, 510, 480, 480, 510, 511, 480, 511, 481,
    481, 511, 512, 481, 512, 482, 482, 512, 513, 482, 513, 483,
    483, 513, 514, 483, 514, 484, 484, 514, 515, 484, 515, 485,
    485, 515, 516, 485, 516, 486, 486, 516, 487, 486, 487, 457,
    487, 517, 488, 487, 488, 458, 488, 518, 519, 488, 519, 489,
    459, 489, 520, 459, 520, 490, 490, 520, 521, 490, 521, 491,
    491, 521, 522, 491, 522, 492, 492, 522, 523, 492, 523, 493,
    493, 523, 524, 493, 524, 494, 494, 524, 525, 494, 525, 495,
    495, 525, 526, 495, 526, 496, 496, 526, 527, 496, 527, 497,
    497, 527, 528, 497, 528, 498, 498, 528, 529, 498, 529, 499,
    499, 529, 530, 499, 530, 500, 500, 530, 531, 500, 531, 501,
    501, 531, 532, 501, 532, 502, 502, 532, 533, 502, 533, 503,
    503, 533, 534, 503, 534, 504, 504, 534, 535, 504, 535, 505,
    505, 535, 536, 505, 536, 506, 506, 536, 537, 506, 537, 507,
    507, 537, 538, 507, 538, 508, 508, 538, 539, 508, 539, 509,
    509, 539, 540, 509, 540, 510, 510, 540, 541, 510, 541, 511,
    511, 541, 542, 511, 542, 512, 512, 542, 543, 512, 543, 513,
    513, 543, 544, 513, 544, 514, 514, 544, 545, 514, 545, 515,
    515, 545, 546, 515, 546, 516, 516, 546, 517, 516, 517, 487,
    517, 547, 518, 517, 518, 488, 518, 548, 549, 518, 549, 519,
    489, 519, 550, 489, 550, 520, 520, 550, 551, 520, 551, 521,
    521, 551, 552, 521, 552, 522, 522, 552, 553, 522, 553, 523,
    523, 553, 554, 523, 554, 524, 524, 554, 555, 524, 555, 525,
    525, 555, 556, 525, 556, 526, 526, 556, 557, 526, 557, 527,
    527, 557, 558, 527, 558, 528, 528, 558, 559, 528, 559, 529,
    529, 559, 560, 529, 560, 530, 530, 560, 561, 530, 561, 531,
    531, 561, 562, 531, 562, 532, 532, 562, 563, 532, 563, 533,
    533, 563, 564, 533, 564, 534, 534, 564, 565, 534, 565, 535,
    535, 565, 566, 535, 566, 536, 536, 566, 567, 536, 567, 537,
    537, 567, 568, 537, 568, 538, 538, 568, 569, 538, 569, 539,
    539, 569, 570, 539, 570, 540, 540, 570, 571, 540, 571, 541,
    541, 571, 572, 541, 572, 542, 542, 572, 573, 542, 573, 543,
    543, 573, 574, 543, 574, 544, 544, 574, 575, 544, 575, 545,
    545, 575, 576, 545, 576, 546, 546, 576, 547, 546, 547, 517,
    547, 577, 548, 547, 548, 518, 548, 578, 579, 548, 579, 549,
    519, 549, 580, 519, 580, 550, 550, 580, 581, 550, 581, 551,
    551, 581, 582, 551, 582, 552, 552, 582, 583, 552, 583, 553,
    553, 583, 584, 553, 584, 554, 554, 584, 585, 554, 585, 555,
    555, 585, 586, 555, 586, 556, 556, 586, 587, 556, 587, 557,
    557, 587, 588, 557, 588, 558, 558, 588, 589, 558, 589, 559,
    559, 589, 590, 559, 590, 560, 560, 590, 591, 560, 591, 561,
    561, 591, 592, 561, 592, 562, 562, 592, 593, 562, 593, 563,
    563, 593, 594, 563, 594, 564, 564, 594, 595, 564, 595, 565,
    565, 595, 596, 565, 596, 566, 566, 596, 597, 566, 597, 567,
    567, 597, 598, 567, 598, 568, 568, 598, 599, 568, 599, 569,
    569, 599, 600, 569, 600, 570, 570, 600, 601, 570, 601, 571,
    571, 601, 602, 571, 602, 572, 572, 602, 603, 572, 603, 573,
    573, 603, 604, 573, 604, 574, 574, 604, 605, 574, 605, 575,
    575, 605, 606, 575, 606, 576, 576, 606, 577, 576, 577, 547,
    577, 607, 578, 577, 578, 548, 578, 608, 579, 549, 579, 609,
    549, 609, 580, 580, 609, 610, 580, 610, 581, 581, 610, 611,
    581, 611, 582, 582, 611, 612, 582, 612, 583, 583, 612, 613,
    583, 613, 584, 584, 613, 614, 584, 614, 585, 585, 614, 615,
    585, 615, 586, 586, 615, 616, 586, 616, 587, 587, 616, 617,
    587, 617, 588, 588, 617, 618, 588, 618, 589, 589, 618, 619,
    589, 619, 590, 590, 619, 620, 590, 620, 591, 591, 620, 621,
    591, 621, 592, 592, 621, 622, 592, 622, 593, 593, 622, 623,
    593, 623, 594, 594, 623, 624, 594, 624, 595, 595, 624, 625,
    595, 625, 596, 596, 625, 626, 596, 626, 597, 597, 626, 627,
    597, 627, 598, 598, 627, 628, 598, 628, 599, 599, 628, 629,
    599, 629, 600, 600, 629, 630, 600, 630, 601, 601, 630, 631,
    601, 631, 602, 602, 631, 632, 602, 632, 603, 603, 632, 633,
    603, 633, 604, 604, 633, 634, 604, 634, 605, 605, 634, 635,
    605, 635, 606, 606, 635, 607, 606, 607, 577, 607, 608, 578,
    579, 608, 609, 609, 608, 610, 610, 608, 611, 611, 608, 612,
    612, 608, 613, 613, 608, 614, 614, 608, 615, 615, 608, 616,
    616, 608, 617, 617, 608, 618, 618, 608, 619, 619, 608, 620,
    620, 608, 621, 621, 608, 622, 622, 608, 623, 623, 608, 624,
    624, 608, 625, 625, 608, 626, 626, 608, 627, 627, 608, 628,
    628, 608, 629, 629, 608, 630, 630, 608, 631, 631, 608, 632,
    632, 608, 633, 633, 608, 634, 634, 608, 635, 635, 608, 607,
    72, 34, 636, 72, 636, 637, 74, 72, 637, 74, 637, 638,
    34, 85, 639, 34, 639, 636, 76, 74, 638, 76, 638, 643,
    78, 76, 643, 78, 643, 642, 81, 78, 642, 81, 642, 641,
    84, 81, 641, 84, 641, 640, 85, 84, 640, 85, 640, 639,
    59, 39, 644, 59, 644, 645, 61, 59, 645, 61, 645, 646,
    38, 36, 647, 38, 647, 644, 64, 61, 646, 64, 646, 652,
    66, 63, 651, 66, 651, 650, 68, 66, 650, 68, 650, 649,
    70, 68, 649, 70, 649, 648, 36, 70, 648, 36, 648, 647,
    53, 50, 653, 53, 653, 654, 55, 53, 654, 55, 654, 655,
    50, 48, 656, 50, 656, 653, 57, 55, 655, 57, 655, 661,
    41, 57, 661, 41, 661, 660, 44, 41, 660, 44, 660, 659,
    46, 44, 659, 46, 659, 658, 48, 45, 657, 48, 657, 656,
    26, 22, 662, 26, 662, 663, 27, 26, 663, 27, 663, 664,
    22, 20, 665, 22, 665, 662, 33, 87, 88, 88, 89, 90,
    90, 91, 92, 92, 93, 0, 0, 80, 83, 86, 35, 33,
    92, 0, 83, 83, 86, 33, 33, 88, 90, 90, 92, 83,
    90, 83, 33, 47, 49, 52, 47, 52, 25, 47, 25, 28,
    28, 21, 19, 19, 29, 30, 30, 31, 32, 32, 33, 35,
    37, 40, 42, 32, 35, 37, 19, 30, 32, 47, 28, 19,
    43, 47, 19, 32, 37, 42, 42, 43, 19, 19, 32, 42,
    37, 35, 73, 73, 75, 77, 71, 37, 73, 69, 71, 73,
    69, 73, 77, 67, 69, 77, 67, 77, 79, 60, 62, 65,
    65, 67, 79, 82, 0, 3, 79, 82, 3, 3, 4, 5,
    5, 6, 7, 7, 8, 9, 9, 10, 11, 11, 12, 13,
    13, 14, 15, 15, 16, 17, 17, 18, 19, 19, 21, 23,
    23, 24, 51, 17, 19, 23, 13, 15, 17, 9, 11, 13,
    5, 7, 9, 79, 3, 5, 79, 5, 9, 13, 17, 23,
    13, 23, 51, 79, 9, 13, 65, 79, 13, 13, 51, 54,
    13, 54, 56, 42, 40, 60, 58, 42, 60, 65, 13, 56,
    56, 58, 60, 56, 60, 65,
  ]),
  normals: new Float32Array([
    -0.05980062, 0.99821034, 0.00000000,
    -0.22980847, 0.97323587, 0.00000000,
    -0.22471200, 0.97325199, -0.04780255,
    -0.05850061, 0.99821036, -0.01240013,
    -0.05460068, 0.99821253, -0.02430030,
    -0.04840054, 0.99821108, -0.03510039,
    -0.04000051, 0.99821268, -0.04440056,
    -0.02990029, 0.99820974, -0.05180051,
    -0.01850016, 0.99820844, -0.05690048,
    -0.00630005, 0.99820839, -0.05950050,
    0.00630005, 0.99820839, -0.05950050,
    0.01850016, 0.99820844, -0.05690048,
    0.02990029, 0.99820974, -0.05180051,
    0.04000051, 0.99821268, -0.04440056,
    0.04840054, 0.99821108, -0.03510039,
    0.05460068, 0.99821253, -0.02430030,
    0.05850061, 0.99821036, -0.01240013,
    0.05980062, 0.99821034, 0.00000000,
    0.05850061, 0.99821036, 0.01240013,
    0.05890118, 0.99791993, 0.02620052,
    -0.20270697, 0.91293134, -0.35421217,
    -0.20270697, 0.91293134, -0.35421217,
    -0.47289867, -0.55209841, 0.68669804,
    -0.47289867, -0.55209841, 0.68669804,
    0.62633813, -0.62213791, 0.46972862,
    0.62630872, -0.62210868, 0.46980654,
    0.62626975, -0.62216997, 0.46977731,
    0.71688179, -0.58928499, -0.37259053,
    0.71688179, -0.58928499, -0.37259053,
    0.04840054, 0.99821108, 0.03510039,
    0.04000051, 0.99821268, 0.04440056,
    0.02990029, 0.99820974, 0.05180051,
    0.01850016, 0.99820844, 0.05690048,
    0.00579973, 0.99845308, 0.05529740,
    -0.24760930, 0.96123610, -0.12130455,
    -0.24770317, 0.96121229, -0.12130155,
    0.10400319, -0.93072845, -0.35061074,
    0.10400319, -0.93072845, -0.35061074,
    -0.29741650, 0.95035270, -0.09150508,
    -0.29750766, 0.95032443, -0.09150235,
    -0.29750766, 0.95032443, -0.09150235,
    0.03570095, -0.91772426, -0.39561045,
    0.03570095, -0.91772426, -0.39561045,
    -0.80423436, -0.57692466, -0.14270609,
    -0.80426970, -0.57687823, -0.14269462,
    -0.76682128, 0.62491734, 0.14650408,
    -0.76683251, 0.62492649, 0.14640621,
    -0.76683251, 0.62492649, 0.14640621,
    -0.68029799, 0.66979804, -0.29759912,
    -0.68029799, 0.66979804, -0.29759912,
    -0.78869888, -0.56829920, 0.23449967,
    -0.78869888, -0.56829920, 0.23449967,
    -0.78871738, -0.56831252, 0.23440517,
    0.19350827, -0.59322538, 0.78143343,
    0.19350827, -0.59322538, 0.78143343,
    0.69578432, -0.65158533, 0.30219319,
    0.69573274, -0.65163066, 0.30221422,
    0.74458580, -0.61918818, -0.24939525,
    0.74458580, -0.61918818, -0.24939525,
    -0.74970101, 0.63640086, 0.18150025,
    -0.74970101, 0.63640086, 0.18150025,
    -0.70679539, 0.65939570, -0.25619833,
    -0.70679539, 0.65939570, -0.25619833,
    -0.78342058, -0.56721494, 0.25400670,
    -0.78345923, -0.56717047, 0.25398679,
    -0.78350367, -0.56710262, 0.25400121,
    0.16850499, -0.60211782, 0.78042309,
    0.16850499, -0.60211782, 0.78042309,
    0.69677839, -0.63898018, 0.32588987,
    0.69677839, -0.63898018, 0.32588987,
    0.74551265, -0.63671075, -0.19700333,
    0.74551265, -0.63671075, -0.19700333,
    -0.74607666, 0.63158024, 0.21089338,
    -0.74607666, 0.63158024, 0.21089338,
    -0.69299085, 0.63959152, -0.33269561,
    -0.69299085, 0.63959152, -0.33269561,
    -0.81598647, -0.56199069, 0.13539775,
    -0.81598647, -0.56199069, 0.13539775,
    0.07769795, -0.60558405, 0.79197916,
    0.07769795, -0.60558405, 0.79197916,
    0.68877650, -0.62457872, 0.36808744,
    0.68872398, -0.62462169, 0.36811277,
    0.68872398, -0.62462169, 0.36811277,
    0.71561615, -0.61351388, -0.33390754,
    0.71557227, -0.61357621, -0.33388706,
    0.23900538, -0.64311452, -0.72751642,
    0.23898800, -0.64306778, -0.72756344,
    -0.00630005, 0.99820839, 0.05950050,
    -0.01850016, 0.99820844, 0.05690048,
    -0.02990029, 0.99820974, 0.05180051,
    -0.04000051, 0.99821268, 0.04440056,
    -0.04840054, 0.99821108, 0.03510039,
    -0.05460068, 0.99821253, 0.02430030,
    -0.05850061, 0.99821036, 0.01240013,
    -0.22471200, 0.97325199, 0.04780255,
    -0.43979830, 0.89809657, 0.00000000,
    -0.43019793, 0.89809568, -0.09139956,
    -0.20969890, 0.97329487, -0.09339951,
    -0.18590659, 0.97323452, -0.13510480,
    -0.15350420, 0.97332658, -0.17050465,
    -0.11470283, 0.97332401, -0.19870490,
    -0.07100194, 0.97322667, -0.21860598,
    -0.02400098, 0.97333966, -0.22810930,
    0.02400098, 0.97333966, -0.22810930,
    0.07100194, 0.97322667, -0.21860598,
    0.11469394, 0.97334861, -0.19858950,
    0.15350420, 0.97332658, -0.17050465,
    0.18590659, 0.97323452, -0.13510480,
    0.20950767, 0.97333567, -0.09340342,
    0.22471200, 0.97325199, -0.04780255,
    0.22980847, 0.97323587, 0.00000000,
    0.22471200, 0.97325199, 0.04780255,
    0.20969890, 0.97329487, 0.09339951,
    0.18590659, 0.97323452, 0.13510480,
    0.15369423, 0.97326347, 0.17069359,
    0.11480380, 0.97333217, 0.19860657,
    0.07099814, 0.97327447, 0.21839428,
    0.02399864, 0.97334492, 0.22808710,
    -0.02399864, 0.97334492, 0.22808710,
    -0.07099814, 0.97327447, 0.21839428,
    -0.11480380, 0.97333217, 0.19860657,
    -0.15369423, 0.97326347, 0.17069359,
    -0.18590659, 0.97323452, 0.13510480,
    -0.20950767, 0.97333567, 0.09340342,
    -0.43019793, 0.89809568, 0.09139956,
    -0.62761756, 0.77852180, 0.00000000,
    -0.61391052, 0.77851335, -0.13050224,
    -0.40179357, 0.89808560, -0.17889713,
    -0.35598830, 0.89797051, -0.25869151,
    -0.29420948, 0.89812898, -0.32681054,
    -0.22000385, 0.89801571, -0.38100668,
    -0.13590467, 0.89803082, -0.41841435,
    -0.04599958, 0.89809176, -0.43739597,
    0.04600148, 0.89822890, -0.43711407,
    0.13590467, 0.89803082, -0.41841435,
    0.22000385, 0.89801571, -0.38100668,
    0.29420948, 0.89812898, -0.32681054,
    0.35580008, 0.89810023, -0.25850006,
    0.40179357, 0.89808560, -0.17889713,
    0.43019793, 0.89809568, -0.09139956,
    0.43979830, 0.89809657, 0.00000000,
    0.43019793, 0.89809568, 0.09139956,
    0.40179357, 0.89808560, 0.17889713,
    0.35598830, 0.89797051, 0.25869151,
    0.29429121, 0.89807319, 0.32689024,
    0.21989731, 0.89808903, 0.38089534,
    0.13590383, 0.89812531, 0.41821177,
    0.04599958, 0.89809176, 0.43739597,
    -0.04599958, 0.89809176, 0.43739597,
    -0.13590383, 0.89812531, 0.41821177,
    -0.21989731, 0.89808903, 0.38089534,
    -0.29429121, 0.89807319, 0.32689024,
    -0.35580008, 0.89810023, 0.25850006,
    -0.40179357, 0.89808560, 0.17889713,
    -0.61391052, 0.77851335, 0.13050224,
    -0.78477526, 0.61978044, 0.00000000,
    -0.76738911, 0.62009120, -0.16309769,
    -0.57343668, 0.77844972, -0.25531629,
    -0.50798741, 0.77828063, -0.36909084,
    -0.42017314, 0.77825028, -0.46667016,
    -0.31398975, 0.77827458, -0.54378223,
    -0.19409639, 0.77818545, -0.59728888,
    -0.06560022, 0.77810270, -0.62470216,
    0.06560022, 0.77810270, -0.62470216,
    0.19409639, 0.77818545, -0.59728888,
    0.31398975, 0.77827458, -0.54378223,
    0.42017314, 0.77825028, -0.46667016,
    0.50798741, 0.77828063, -0.36909084,
    0.57343668, 0.77844972, -0.25531629,
    0.61391052, 0.77851335, -0.13050224,
    0.62761756, 0.77852180, 0.00000000,
    0.61391052, 0.77851335, 0.13050224,
    0.57343668, 0.77844972, 0.25531629,
    0.50798741, 0.77828063, 0.36909084,
    0.42009080, 0.77828296, 0.46668977,
    0.31389223, 0.77838077, 0.54368654,
    0.19399664, 0.77828648, 0.59718964,
    0.06550375, 0.77824445, 0.62453569,
    -0.06550375, 0.77824445, 0.62453569,
    -0.19399664, 0.77828648, 0.59718964,
    -0.31389223, 0.77838077, 0.54368654,
    -0.42009080, 0.77828296, 0.46668977,
    -0.50798741, 0.77828063, 0.36909084,
    -0.57343668, 0.77844972, 0.25531629,
    -0.76738911, 0.62009120, 0.16309769,
    -0.90236087, 0.43098128, 0.00000000,
    -0.88288393, 0.43049215, -0.18759658,
    -0.71683475, 0.61993005, -0.31911547,
    -0.63481510, 0.61991472, -0.46121094,
    -0.52517318, 0.61966842, -0.58327025,
    -0.39229617, 0.61999393, -0.67949337,
    -0.24250947, 0.61982417, -0.74632912,
    -0.08190100, 0.62000751, -0.78030950,
    0.08199901, 0.61989253, -0.78039055,
    0.24250947, 0.61982417, -0.74632912,
    0.39229384, 0.61989022, -0.67958933,
    0.52517318, 0.61966842, -0.58327025,
    0.63481510, 0.61991472, -0.46121094,
    0.71683475, 0.61993005, -0.31911547,
    0.76738911, 0.62009120, -0.16309769,
    0.78477526, 0.61978044, 0.00000000,
    0.76738911, 0.62009120, 0.16309769,
    0.71683475, 0.61993005, 0.31911547,
    0.63481510, 0.61991472, 0.46121094,
    0.52512562, 0.62003028, 0.58292841,
    0.39229617, 0.61999393, 0.67949337,
    0.24258547, 0.61976287, 0.74635532,
    0.08210096, 0.62010733, 0.78020916,
    -0.08210096, 0.62010733, 0.78020916,
    -0.24258547, 0.61976287, 0.74635532,
    -0.39229617, 0.61999393, 0.67949337,
    -0.52509887, 0.61979868, 0.58319874,
    -0.63481510, 0.61991472, 0.46121094,
    -0.71683475, 0.61993005, 0.31911547,
    -0.88268771, 0.43089400, 0.18759738,
    -0.97529663, 0.22089924, 0.00000000,
    -0.95400508, 0.22060116, -0.20300107,
    -0.82437009, 0.43088436, -0.36708668,
    -0.73021001, 0.43040592, -0.53060728,
    -0.60376194, 0.43107287, -0.67055776,
    -0.45111705, 0.43111632, -0.78142954,
    -0.27880033, 0.43100049, -0.85820100,
    -0.09430093, 0.43100424, -0.89740887,
    0.09429620, 0.43068263, -0.89756376,
    0.27880033, 0.43100049, -0.85820100,
    0.45129943, 0.43079946, -0.78149898,
    0.60378798, 0.43099142, -0.67058666,
    0.73007632, 0.43078602, -0.53048277,
    0.82437009, 0.43088436, -0.36708668,
    0.88288393, 0.43049215, -0.18759658,
    0.90230338, 0.43110161, 0.00000000,
    0.88262757, 0.43101348, 0.18760586,
    0.82433277, 0.43101713, 0.36701461,
    0.73021001, 0.43040592, 0.53060728,
    0.60376194, 0.43107287, 0.67055776,
    0.45111705, 0.43111632, 0.78142954,
    0.27880033, 0.43100049, 0.85820100,
    0.09430093, 0.43100424, 0.89740887,
    -0.09429620, 0.43068263, 0.89756376,
    -0.27869606, 0.43109396, 0.85818792,
    -0.45111705, 0.43111632, 0.78142954,
    -0.60380243, 0.43110176, 0.67050271,
    -0.73007632, 0.43078602, 0.53048277,
    -0.82433277, 0.43101713, 0.36701461,
    -0.95404379, 0.22061011, 0.20280932,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.97662549, 0.05570145, -0.20760542,
    -0.97662549, 0.05570145, -0.20760542,
    -0.89097426, 0.22109362, -0.39658855,
    -0.78902109, 0.22080592, -0.57331533,
    -0.65260832, 0.22080282, -0.72480928,
    -0.48759211, 0.22119642, -0.84458633,
    -0.30139453, 0.22079598, -0.92758314,
    -0.10189677, 0.22129300, -0.96986930,
    0.10189677, 0.22129300, -0.96986930,
    0.30139453, 0.22079598, -0.92758314,
    0.48759211, 0.22119642, -0.84458633,
    0.65250764, 0.22110260, -0.72480854,
    0.78902109, 0.22080592, -0.57331533,
    0.89097426, 0.22109362, -0.39658855,
    0.95400508, 0.22060116, -0.20300107,
    0.97529663, 0.22089924, 0.00000000,
    0.95404379, 0.22061011, 0.20280932,
    0.89097426, 0.22109362, 0.39658855,
    0.78902109, 0.22080592, 0.57331533,
    0.65260832, 0.22080282, 0.72480928,
    0.48760288, 0.22110131, 0.84460502,
    0.30138787, 0.22089110, 0.92756265,
    0.10189903, 0.22119788, 0.96989076,
    -0.10189677, 0.22129300, 0.96986930,
    -0.30140915, 0.22100672, 0.92752820,
    -0.48779650, 0.22109842, 0.84449397,
    -0.65238854, 0.22119611, 0.72488722,
    -0.78902109, 0.22080592, 0.57331533,
    -0.89097426, 0.22109362, 0.39658855,
    -0.97662004, 0.05580114, 0.20760425,
    -0.97662004, 0.05580114, 0.20760425,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97814792, 0.00000000, -0.20791019,
    -0.91216314, 0.05599774, -0.40598357,
    -0.91216314, 0.05599774, -0.40598357,
    -0.80775714, 0.05579704, -0.58686889,
    -0.80775714, 0.05579704, -0.58686889,
    -0.66813405, 0.05590285, -0.74193784,
    -0.66813405, 0.05590285, -0.74193784,
    -0.49938821, 0.05579868, -0.86457962,
    -0.49938821, 0.05579868, -0.86457962,
    -0.30861232, 0.05600223, -0.94953788,
    -0.30861232, 0.05600223, -0.94953788,
    -0.10439501, 0.05609732, -0.99295255,
    -0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.30861232, 0.05600223, -0.94953788,
    0.30861232, 0.05600223, -0.94953788,
    0.49938821, 0.05579868, -0.86457962,
    0.49938821, 0.05579868, -0.86457962,
    0.66813405, 0.05590285, -0.74193784,
    0.66813405, 0.05590285, -0.74193784,
    0.80780907, 0.05570062, -0.58680656,
    0.80780907, 0.05570062, -0.58680656,
    0.91216314, 0.05599774, -0.40598357,
    0.91216314, 0.05599774, -0.40598357,
    0.97662549, 0.05570145, -0.20760542,
    0.97662549, 0.05570145, -0.20760542,
    0.99844184, 0.05580234, 0.00000000,
    0.99844184, 0.05580234, 0.00000000,
    0.97662004, 0.05580114, 0.20760425,
    0.97662004, 0.05580114, 0.20760425,
    0.91205048, 0.05569697, 0.40627795,
    0.91205048, 0.05569697, 0.40627795,
    0.80775714, 0.05579704, 0.58686889,
    0.80775714, 0.05579704, 0.58686889,
    0.66813405, 0.05590285, 0.74193784,
    0.66813405, 0.05590285, 0.74193784,
    0.49931595, 0.05570178, 0.86462760,
    0.49931595, 0.05570178, 0.86462760,
    0.30849597, 0.05579927, 0.94958764,
    0.30849597, 0.05579927, 0.94958764,
    0.10439560, 0.05599764, 0.99295812,
    0.10439560, 0.05599764, 0.99295812,
    -0.10439501, 0.05609732, 0.99295255,
    -0.10439501, 0.05609732, 0.99295255,
    -0.30861403, 0.05590254, 0.94954320,
    -0.30861403, 0.05590254, 0.94954320,
    -0.49932150, 0.05550239, 0.86463722,
    -0.49932150, 0.05550239, 0.86463722,
    -0.66819688, 0.05569974, 0.74189653,
    -0.66819688, 0.05569974, 0.74189653,
    -0.80780907, 0.05570062, 0.58680656,
    -0.80780907, 0.05570062, 0.58680656,
    -0.91215802, 0.05609742, 0.40598131,
    -0.91215802, 0.05609742, 0.40598131,
    -0.97814792, 0.00000000, 0.20791019,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.97662549, -0.05570145, -0.20760542,
    -0.97662549, -0.05570145, -0.20760542,
    -0.91360525, 0.00000000, -0.40660231,
    -0.80895657, 0.00000000, -0.58786841,
    -0.66913599, 0.00000000, -0.74313998,
    -0.50012935, 0.00000000, -0.86595071,
    -0.30910870, 0.00000000, -0.95102672,
    -0.10460149, 0.00000000, -0.99451422,
    0.10460149, 0.00000000, -0.99451422,
    0.30910870, 0.00000000, -0.95102672,
    0.50012935, 0.00000000, -0.86595071,
    0.66913599, 0.00000000, -0.74313998,
    0.80895657, 0.00000000, -0.58786841,
    0.91360525, 0.00000000, -0.40660231,
    0.97814792, 0.00000000, -0.20791019,
    1.00000000, 0.00000000, 0.00000000,
    0.97814792, 0.00000000, 0.20791019,
    0.91360525, 0.00000000, 0.40660231,
    0.80895657, 0.00000000, 0.58786841,
    0.66913599, 0.00000000, 0.74313998,
    0.50001101, 0.00000000, 0.86601905,
    0.30910870, 0.00000000, 0.95102672,
    0.10460149, 0.00000000, 0.99451422,
    -0.10460149, 0.00000000, 0.99451422,
    -0.30910870, 0.00000000, 0.95102672,
    -0.50012935, 0.00000000, 0.86595071,
    -0.66913599, 0.00000000, 0.74313998,
    -0.80895657, 0.00000000, 0.58786841,
    -0.91360525, 0.00000000, 0.40660231,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97527509, -0.22099435, 0.00000000,
    -0.95393118, -0.22100722, -0.20290665,
    -0.91216314, -0.05599774, -0.40598357,
    -0.91216314, -0.05599774, -0.40598357,
    -0.80780907, -0.05570062, -0.58680656,
    -0.80780907, -0.05570062, -0.58680656,
    -0.66813405, -0.05590285, -0.74193784,
    -0.66813405, -0.05590285, -0.74193784,
    -0.49938821, -0.05579868, -0.86457962,
    -0.49938821, -0.05579868, -0.86457962,
    -0.30861232, -0.05600223, -0.94953788,
    -0.30861232, -0.05600223, -0.94953788,
    -0.10439501, -0.05609732, -0.99295255,
    -0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.30861232, -0.05600223, -0.94953788,
    0.30861232, -0.05600223, -0.94953788,
    0.49938821, -0.05579868, -0.86457962,
    0.49938821, -0.05579868, -0.86457962,
    0.66813405, -0.05590285, -0.74193784,
    0.66813405, -0.05590285, -0.74193784,
    0.80780907, -0.05570062, -0.58680656,
    0.80780907, -0.05570062, -0.58680656,
    0.91216314, -0.05599774, -0.40598357,
    0.91216314, -0.05599774, -0.40598357,
    0.97662549, -0.05570145, -0.20760542,
    0.97662549, -0.05570145, -0.20760542,
    0.99844184, -0.05580234, 0.00000000,
    0.99844184, -0.05580234, 0.00000000,
    0.97662004, -0.05580114, 0.20760425,
    0.97662004, -0.05580114, 0.20760425,
    0.91208245, -0.05579893, 0.40619217,
    0.91208245, -0.05579893, 0.40619217,
    0.80780907, -0.05570062, 0.58680656,
    0.80780907, -0.05570062, 0.58680656,
    0.66813405, -0.05590285, 0.74193784,
    0.66813405, -0.05590285, 0.74193784,
    0.49931595, -0.05570178, 0.86462760,
    0.49931595, -0.05570178, 0.86462760,
    0.30849597, -0.05579927, 0.94958764,
    0.30849597, -0.05579927, 0.94958764,
    0.10439560, -0.05599764, 0.99295812,
    0.10439560, -0.05599764, 0.99295812,
    -0.10439501, -0.05609732, 0.99295255,
    -0.10439501, -0.05609732, 0.99295255,
    -0.30861403, -0.05590254, 0.94954320,
    -0.30861403, -0.05590254, 0.94954320,
    -0.49918934, -0.05599880, 0.86468152,
    -0.49918934, -0.05599880, 0.86468152,
    -0.66819688, -0.05569974, 0.74189653,
    -0.66819688, -0.05569974, 0.74189653,
    -0.80780907, -0.05570062, 0.58680656,
    -0.80780907, -0.05570062, 0.58680656,
    -0.91208245, -0.05579893, 0.40619217,
    -0.91208245, -0.05579893, 0.40619217,
    -0.95395953, -0.22099063, 0.20279139,
    -0.90239973, -0.43089990, 0.00000000,
    -0.88268771, -0.43089400, -0.18759738,
    -0.89091830, -0.22110454, -0.39670815,
    -0.78902109, -0.22080592, -0.57331533,
    -0.65259796, -0.22119932, -0.72469771,
    -0.48761365, -0.22100619, -0.84462370,
    -0.30138787, -0.22089110, -0.92756265,
    -0.10190352, -0.22100767, -0.96993365,
    0.10190352, -0.22100767, -0.96993365,
    0.30138787, -0.22089110, -0.92756265,
    0.48762444, -0.22091107, -0.84464235,
    0.65259796, -0.22119932, -0.72469771,
    0.78895134, -0.22118637, -0.57326466,
    0.89099798, -0.22079950, -0.39669909,
    0.95393118, -0.22100722, -0.20290665,
    0.97527509, -0.22099435, 0.00000000,
    0.95395953, -0.22099063, 0.20279139,
    0.89101765, -0.22070437, 0.39670785,
    0.78902109, -0.22080592, 0.57331533,
    0.65259796, -0.22119932, 0.72469771,
    0.48762444, -0.22091107, 0.84464235,
    0.30139453, -0.22079598, 0.92758314,
    0.10189815, -0.22079600, 0.96998242,
    -0.10190352, -0.22100767, 0.96993365,
    -0.30139453, -0.22079598, 0.92758314,
    -0.48761365, -0.22100619, 0.84462370,
    -0.65257545, -0.22069170, 0.72487272,
    -0.78895134, -0.22118637, 0.57326466,
    -0.89101765, -0.22070437, 0.39670785,
    -0.88270918, -0.43080445, 0.18770195,
    -0.78468818, -0.61989069, 0.00000000,
    -0.76738911, -0.62009120, -0.16309769,
    -0.82440561, -0.43080291, -0.36710250,
    -0.73010776, -0.43070458, -0.53050564,
    -0.60379085, -0.43129347, -0.67038986,
    -0.45117726, -0.43117823, -0.78136061,
    -0.27869596, -0.43129376, -0.85808756,
    -0.09429687, -0.43108568, -0.89737018,
    0.09429687, -0.43108568, -0.89737018,
    0.27869596, -0.43129376, -0.85808756,
    0.45121980, -0.43081888, -0.78153425,
    0.60377641, -0.43118315, -0.67047382,
    0.73010776, -0.43070458, -0.53050564,
    0.82440561, -0.43080291, -0.36710250,
    0.88268771, -0.43089400, -0.18759738,
    0.90226449, -0.43118302, 0.00000000,
    0.88270918, -0.43080445, 0.18770195,
    0.82447315, -0.43068597, 0.36708803,
    0.73010776, -0.43070458, 0.53050564,
    0.60379085, -0.43129347, 0.67038986,
    0.45117726, -0.43117823, 0.78136061,
    0.27869596, -0.43129376, 0.85808756,
    0.09429687, -0.43108568, 0.89737018,
    -0.09429687, -0.43108568, 0.89737018,
    -0.27878830, -0.43108192, 0.85816401,
    -0.45111705, -0.43111632, 0.78142954,
    -0.60378798, -0.43099142, 0.67058666,
    -0.73010776, -0.43070458, 0.53050564,
    -0.82433277, -0.43101713, 0.36701461,
    -0.76738911, -0.62009120, 0.16309769,
    -0.62761756, -0.77852180, 0.00000000,
    -0.61391052, -0.77851335, -0.13050224,
    -0.71683475, -0.61993005, -0.31911547,
    -0.63481510, -0.61991472, -0.46121094,
    -0.52509499, -0.61999411, -0.58299447,
    -0.39229617, -0.61999393, -0.67949337,
    -0.24260050, -0.61970132, -0.74640155,
    -0.08190100, -0.62000751, -0.78030950,
    0.08220010, -0.61960083, -0.78060102,
    0.24260050, -0.61970132, -0.74640155,
    0.39231817, -0.61982866, -0.67963143,
    0.52517318, -0.61966842, -0.58327025,
    0.63481510, -0.61991472, -0.46121094,
    0.71683475, -0.61993005, -0.31911547,
    0.76738911, -0.62009120, -0.16309769,
    0.78468818, -0.61989069, 0.00000000,
    0.76738911, -0.62009120, 0.16309769,
    0.71683475, -0.61993005, 0.31911547,
    0.63481510, -0.61991472, 0.46121094,
    0.52519610, -0.62009539, 0.58279564,
    0.39229617, -0.61999393, 0.67949337,
    0.24258547, -0.61976287, 0.74635532,
    0.08210096, -0.62010733, 0.78020916,
    -0.08210096, -0.62010733, 0.78020916,
    -0.24258547, -0.61976287, 0.74635532,
    -0.39229850, -0.62009760, 0.67939742,
    -0.52509887, -0.61979868, 0.58319874,
    -0.63481510, -0.61991472, 0.46121094,
    -0.71683475, -0.61993005, 0.31911547,
    -0.61391052, -0.77851335, 0.13050224,
    -0.43979830, -0.89809657, 0.00000000,
    -0.43019793, -0.89809568, -0.09139956,
    -0.57371263, -0.77821706, -0.25540560,
    -0.50798741, -0.77828063, -0.36909084,
    -0.42017314, -0.77825028, -0.46667016,
    -0.31398975, -0.77827458, -0.54378223,
    -0.19409639, -0.77818545, -0.59728888,
    -0.06560022, -0.77810270, -0.62470216,
    0.06560022, -0.77810270, -0.62470216,
    0.19409639, -0.77818545, -0.59728888,
    0.31398975, -0.77827458, -0.54378223,
    0.42017314, -0.77825028, -0.46667016,
    0.50798741, -0.77828063, -0.36909084,
    0.57371263, -0.77821706, -0.25540560,
    0.61391052, -0.77851335, -0.13050224,
    0.62761756, -0.77852180, 0.00000000,
    0.61391052, -0.77851335, 0.13050224,
    0.57371263, -0.77821706, 0.25540560,
    0.50798741, -0.77828063, 0.36909084,
    0.42009080, -0.77828296, 0.46668977,
    0.31389223, -0.77838077, 0.54368654,
    0.19399664, -0.77828648, 0.59718964,
    0.06550375, -0.77824445, 0.62453569,
    -0.06550375, -0.77824445, 0.62453569,
    -0.19399664, -0.77828648, 0.59718964,
    -0.31389223, -0.77838077, 0.54368654,
    -0.42009080, -0.77828296, 0.46668977,
    -0.50798741, -0.77828063, 0.36909084,
    -0.57371263, -0.77821706, 0.25540560,
    -0.43019793, -0.89809568, 0.09139956,
    -0.22980847, -0.97323587, 0.00000000,
    -0.22471200, -0.97325199, -0.04780255,
    -0.40179357, -0.89808560, -0.17889713,
    -0.35580008, -0.89810023, -0.25850006,
    -0.29449069, -0.89797161, -0.32698964,
    -0.22000385, -0.89801571, -0.38100668,
    -0.13590467, -0.89803082, -0.41841435,
    -0.04600148, -0.89822890, -0.43711407,
    0.04600148, -0.89822890, -0.43711407,
    0.13589899, -0.89799323, -0.41849686,
    0.22000385, -0.89801571, -0.38100668,
    0.29420948, -0.89812898, -0.32681054,
    0.35580008, -0.89810023, -0.25850006,
    0.40179357, -0.89808560, -0.17889713,
    0.43019793, -0.89809568, -0.09139956,
    0.43979830, -0.89809657, 0.00000000,
    0.43019793, -0.89809568, 0.09139956,
    0.40179357, -0.89808560, 0.17889713,
    0.35580008, -0.89810023, 0.25850006,
    0.29429121, -0.89807319, 0.32689024,
    0.21989731, -0.89808903, 0.38089534,
    0.13590383, -0.89812531, 0.41821177,
    0.04599958, -0.89809176, 0.43739597,
    -0.04599958, -0.89809176, 0.43739597,
    -0.13590383, -0.89812531, 0.41821177,
    -0.21989731, -0.89808903, 0.38089534,
    -0.29429121, -0.89807319, 0.32689024,
    -0.35580008, -0.89810023, 0.25850006,
    -0.40179357, -0.89808560, 0.17889713,
    -0.22471200, -0.97325199, 0.04780255,
    -0.05999990, -0.99819838, 0.00000000,
    -0.05850061, -0.99821036, -0.01240013,
    -0.20969890, -0.97329487, -0.09339951,
    -0.18590659, -0.97323452, -0.13510480,
    -0.15370656, -0.97324157, -0.17080729,
    -0.11490453, -0.97323832, -0.19900783,
    -0.07100194, -0.97322667, -0.21860598,
    -0.02400098, -0.97333966, -0.22810930,
    0.02399879, -0.97325079, -0.22848844,
    0.07100194, -0.97322667, -0.21860598,
    0.11490453, -0.97323832, -0.19900783,
    0.15350420, -0.97332658, -0.17050465,
    0.18590659, -0.97323452, -0.13510480,
    0.20950767, -0.97333567, -0.09340342,
    0.22471200, -0.97325199, -0.04780255,
    0.22980847, -0.97323587, 0.00000000,
    0.22471200, -0.97325199, 0.04780255,
    0.20969890, -0.97329487, 0.09339951,
    0.18590659, -0.97323452, 0.13510480,
    0.15369160, -0.97324685, 0.17079067,
    0.11480380, -0.97333217, 0.19860657,
    0.07099814, -0.97327447, 0.21839428,
    0.02399864, -0.97334492, 0.22808710,
    -0.02399864, -0.97334492, 0.22808710,
    -0.07099814, -0.97327447, 0.21839428,
    -0.11480380, -0.97333217, 0.19860657,
    -0.15369160, -0.97324685, 0.17079067,
    -0.18590659, -0.97323452, 0.13510480,
    -0.20950767, -0.97333567, 0.09340342,
    -0.05850061, -0.99821036, 0.01240013,
    0.00000000, -1.00000000, 0.00000000,
    -0.05509891, -0.99818029, -0.02449951,
    -0.04859973, -0.99819437, -0.03529980,
    -0.04039896, -0.99817434, -0.04489885,
    -0.02990014, -0.99820456, -0.05190024,
    -0.01850026, -0.99821411, -0.05680080,
    -0.00630005, -0.99820839, -0.05950050,
    0.00630005, -0.99820839, -0.05950050,
    0.01850026, -0.99821411, -0.05680080,
    0.02999989, -0.99819639, -0.05199981,
    0.04039896, -0.99817434, -0.04489885,
    0.04859973, -0.99819437, -0.03529980,
    0.05509891, -0.99818029, -0.02449951,
    0.05850061, -0.99821036, -0.01240013,
    0.05999990, -0.99819838, 0.00000000,
    0.05850061, -0.99821036, 0.01240013,
    0.05509891, -0.99818029, 0.02449951,
    0.04859973, -0.99819437, 0.03529980,
    0.04019983, -0.99819579, 0.04459981,
    0.03000005, -0.99820157, 0.05190008,
    0.01859991, -0.99819520, 0.05709973,
    0.00630005, -0.99820839, 0.05950050,
    -0.00630005, -0.99820839, 0.05950050,
    -0.01859991, -0.99819520, 0.05709973,
    -0.03000005, -0.99820157, 0.05190008,
    -0.04019983, -0.99819579, 0.04459981,
    -0.04859973, -0.99819437, 0.03529980,
    -0.05509891, -0.99818029, 0.02449951,
    -0.74999283, 0.55029475, -0.36699652,
    -0.74607666, -0.63158024, 0.21089338,
    -0.69299085, -0.63959152, -0.33269561,
    0.23909967, 0.64309915, -0.72749902,
    0.71557227, 0.61357621, -0.33388706,
    0.68872398, 0.62462169, 0.36811277,
    0.07769795, 0.60558405, 0.79197916,
    -0.81598647, 0.56199069, 0.13539775,
    -0.78736058, 0.56697158, -0.24208788,
    -0.74970101, -0.63640086, 0.18150025,
    -0.70679539, -0.65939570, -0.25619833,
    0.22950739, 0.59061905, -0.77362491,
    0.74565198, 0.63654436, -0.19701373,
    0.69668240, 0.63908387, 0.32589177,
    0.16850499, 0.60211782, 0.78042309,
    -0.78342058, 0.56721494, 0.25400670,
    -0.78345923, 0.56717047, 0.25398679,
    -0.78869888, 0.56829920, 0.23449967,
    0.19350827, 0.59322538, 0.78143343,
    0.69578432, 0.65158533, 0.30219319,
    -0.68029799, -0.66979804, -0.29759912,
    -0.76682128, -0.62491734, 0.14650408,
    -0.76683251, -0.62492649, 0.14640621,
    -0.80426970, 0.57687823, -0.14269462,
    0.07270145, 0.58741173, -0.80601610,
    0.74458580, 0.61918818, -0.24939525,
    -0.47289867, 0.55209841, 0.68669804,
    0.62620898, 0.62220891, 0.46980675,
    0.71688179, 0.58928499, -0.37259053,
    -0.41030670, 0.56350920, -0.71701171,
  ]),
  materialIndex: 0,
};

const AIR_MESH_1: RuneMesh = {
  name: "Air_Rune_primitive1",
  positions: new Float32Array([
    0.00770000, 0.36710003, 0.57789999,
    -0.31160000, 0.36710000, 0.16689996,
    -0.27079999, 0.36709997, -0.20330003,
    -0.17569999, 0.36710003, 0.57789999,
    -0.54930001, 0.36710003, 0.30279997,
    -0.50860000, 0.36709997, -0.34260002,
    -0.13490000, 0.36709994, -0.62790000,
    0.05870000, 0.36709997, -0.53280002,
    0.23870000, 0.36710003, 0.48619998,
    0.05530000, 0.36710003, 0.21449997,
    0.09950000, 0.36710000, -0.15580003,
    0.10290000, 0.36710003, 0.54060000,
    -0.13150001, 0.36710003, 0.20769997,
    -0.08740000, 0.36709997, -0.24750003,
    0.15040000, 0.36709997, -0.48870003,
    0.28290001, 0.36709997, -0.43770003,
    0.51730001, 0.36709997, -0.34940004,
    0.42219999, 0.36709997, -0.39020002,
    0.19120000, 0.36710000, -0.10480003,
    0.33379999, 0.36710000, -0.07430003,
    0.28630000, 0.36710000, 0.12279997,
    0.47310001, 0.36710003, 0.38769996,
    0.38479999, 0.36710003, 0.44879997,
    0.14700000, 0.36710003, 0.21109997,
    0.61240000, 0.36710000, -0.16260003,
    0.41880000, 0.36710000, -0.06070003,
    0.38139999, 0.36710000, 0.12279997,
    0.56819999, 0.36710003, 0.20429997,
  ]),
  indices: new Uint16Array([
    1, 0, 3, 3, 4, 5, 5, 6, 7, 5, 7, 2,
    1, 3, 5, 1, 5, 2, 9, 8, 11, 11, 12, 13,
    13, 14, 15, 13, 15, 10, 9, 11, 13, 9, 13, 10,
    18, 17, 16, 18, 16, 19, 22, 23, 18, 20, 21, 22,
    18, 19, 20, 20, 22, 18, 25, 24, 27, 25, 27, 26,
  ]),
  normals: new Float32Array([
    -0.74990780, 0.55040574, -0.36700383,
    -0.74607666, -0.63158024, 0.21089338,
    -0.69303517, -0.63953243, -0.33271688,
    0.23900538, 0.64311452, -0.72751642,
    0.71557227, 0.61357621, -0.33388706,
    0.68872398, 0.62462169, 0.36811277,
    0.07769795, 0.60558405, 0.79197916,
    -0.81598647, 0.56199069, 0.13539775,
    -0.78736058, 0.56697158, -0.24208788,
    -0.74970101, -0.63640086, 0.18150025,
    -0.70679539, -0.65939570, -0.25619833,
    0.22950739, 0.59061905, -0.77362491,
    0.74560449, 0.63660386, -0.19700120,
    0.69668240, 0.63908387, 0.32589177,
    0.16850499, 0.60211782, 0.78042309,
    -0.78345923, 0.56717047, 0.25398679,
    -0.78869888, 0.56829920, 0.23449967,
    0.19350827, 0.59322538, 0.78143343,
    0.69578432, 0.65158533, 0.30219319,
    -0.68029799, -0.66979804, -0.29759912,
    -0.76678457, -0.62498745, 0.14639706,
    -0.80426970, 0.57687823, -0.14269462,
    0.07270145, 0.58741173, -0.80601610,
    0.74458580, 0.61918818, -0.24939525,
    -0.47289867, 0.55209841, 0.68669804,
    0.62620898, 0.62220891, 0.46980675,
    0.71688179, 0.58928499, -0.37259053,
    -0.41030670, 0.56350920, -0.71701171,
  ]),
  materialIndex: 1,
};

export const AIR_MESHES: RuneMesh[] = [
  AIR_MESH_0,
  AIR_MESH_1,
];
